import styled from 'styled-components';

export const PriceValue = styled.span`
  font-size: 0.875rem;
  font-weight: bold;
  color: #000;
`;
